module.exports = __webpack_public_path__ + "img/5s.681e71ea.png";